import React from "react"
import { useDesktop } from '@reveel/helpers/MediaQueries'
import MobileProfile from './mobile'
import DesktopProfile from './desktop'

const ProfileScreen = (props) => (useDesktop() ? <DesktopProfile {...props} /> : <MobileProfile {...props} />)

export default ProfileScreen
